import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { AmplifyService } from "../services/amplify.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Title } from "@angular/platform-browser";
import userflow from "userflow.js";
import { Platform } from "@ionic/angular";

@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: ["./home.page.scss"],
})
export class HomePage implements OnInit {
  flags: any;
  notificationsEnabled: boolean = false; // Default to off

  constructor(
    public app: AppService,
    private http: HttpService,
    public amplify: AmplifyService,
    private router: Router,
    public title: Title,
    private platform: Platform
  ) {
    this.flags = {
      defaultDevice: {
        cid: null,
        company_id: null,
        user_id: null,
        epoch: null,
        fcm_token: null,
        active: true,
        endpoint: null,
      },
    };

    if (!this.app.sysData.isLoggedIn) {
      this.router.navigateByUrl("/login");
    }
  }

  ionViewWillEnter() {
    this.app.setupNav();
  }

  getData() {}

  viewPage(m) {
    this.router.navigateByUrl("/" + m);
  }

  callSetNotifications(enabled: boolean) {
    this.notificationsEnabled = enabled;
    // Additional logic to handle enabling/disabling notifications
    if (enabled) {
      this.setNotifications(true);
    } else {
      this.setNotifications(false);
    }
  }

  setNotifications(m) {
    var obj = {
      cid: this.app.sysData.cognitoUser.sub,
      active: m,
    };
    this.http
      .apiPost("setNotifications", { data: obj }, null)
      .then((data) => {
        console.log("device saved", data);
        if (m) {
          this.app.toast("Notification settings are now ON", "success");
        } else {
          this.app.toast("Notification settings are now OFF", "tertiary");
        }
      })
      .catch((err) => {
        //this.navCtrl.navigateRoot('/account');
        this.app.alert("Could update account, Please try again later or contact us");
      });
  }

  updateDeviceToken() {
    var obj = JSON.parse(JSON.stringify(this.flags.defaultDevice));
    obj.cid = this.app.sysData.cognitoUser.sub;
    obj.company_id = this.app.sysData.company_id;
    obj.user_id = this.app.sysData.userId;
    obj.fcm_token = this.app.sysData.fcmToken;
    obj.epoch = Date.now();
    obj.active = 1;

    if (obj.fcm_token) {
      this.http.apiPost("addFCM", { data: obj }, null).then((data) => {
        console.log("device saved", data);
      });
    }
  }

  ngOnInit() {
    this.title.setTitle("Arii Connect Dashboard");
    // Initialize Userflow
    if (!this.platform.is("ios") && !this.platform.is("android")) {
      let userIndustryTags = [];
      let connect_pro;
      let permission;
      Object.values(this.app.sysData.userAccess).forEach((element) => {
        if (element["industry"] != null) {
          userIndustryTags.push(element["industry"]);
        }
        if (element["permissions"] == 1) {
          permission = "Design";
        } else if (element["permissions"] == 2) {
          permission = "Support";
        } else if (element["permissions"] == 3) {
          permission = "Design & Support";
        } else if (element["permissions"] == 5) {
          permission = "Reports";
        } else if (element["permissions"] == 9) {
          permission = ["Admin", "Design", "Support", "Reports"];
        }
        connect_pro = element["connect_pro"];
      });
      userflow.init("ct_o5kifob3zfe3xjjgboud2yjlyu");

      userflow.identify(Object.values<string>(this.app.sysData.cognitoUser)[0], {
        name: this.app.sysData.agent_name,
        email: Object.values(this.app.sysData.cognitoUser)[2],
        industry: userIndustryTags,
        connect_pro: connect_pro,
        permission: permission,
      });
    }
  }
}
